import React, { useCallback, useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { getCurrentUser } from 'aws-amplify/auth';
import { api_url } from '../api/config/config';

const Footer: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const checkAuthenticated = useCallback(async () => {
        try {
            const { username, userId } = await getCurrentUser();
            setIsAuthenticated(Boolean(username && userId));
        } catch (error) {
            setIsAuthenticated(false);
        }
    }, []);

    useEffect(() => {
        checkAuthenticated();
    }, [checkAuthenticated]);

    const getTermsSignedUrl = async (): Promise<string> => {
        const response = await fetch(`${api_url}/getTermsOfUseUrl`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const contentType = response.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
            throw new Error('利用規約URLの取得に失敗しました。');
        }

        const res = await response.json();
        const signedUrl = res?.data?.signed_url;
        if (!response.ok || !signedUrl) {
            throw new Error(res?.message || '利用規約URLの取得に失敗しました。');
        }

        return signedUrl;
    };

    const handleDownload = async (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        try {
            const signedUrl = await getTermsSignedUrl();
            window.open(signedUrl, '_blank', 'noopener,noreferrer');
        } catch (error: any) {
            alert(error?.message || '利用規約の取得に失敗しました。');
        }
    };

    return (
        <>
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 order-xl-2 text-xl-right text-md-left text-center">
                            <div className="navbar1">
                                <ul className="navbar-nav1 mt-xl-2">
                                    {
                                        isAuthenticated ? <li className="nav-item">
                                            <a className="nav-link text-white" onClick={handleDownload} href="">利用規約</a>
                                        </li> : null
                                    }

                                    <li className="nav-item">
                                        <a className="nav-link text-white" href="https://enecloud.co.jp/privacy-policy" target="_blank" rel="noreferrer">プライバシーポリシー</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link text-white" href="https://enecloud.co.jp/about_us" target="_blank" rel="noreferrer">運営会社情報</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-5 text-sm-left text-center">
                            <a className="navbar-brand p-0" href="/">
                                <Image fluid src="assets/images/ENECLOUD_logo.png" alt="LOGO" />
                            </a>
                            <div className="copyright-text text-white fw-400">
                                Enebid powered by ENECLOUD
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;